import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataEstasMil = localStorage.getItem("userDataEstasMil") ? JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil"))) : "";
var serviceName = "controller";
var controllerService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataEstasMil["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataEstasMil["firmaKodu"]+"/kucuk/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataEstasMil["firmaKodu"]+"/enkucuk/",
    resimYukle(modul,name, base) {
        var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "resimyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuResim(modul) {
        var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                modul: modul,
                methodName: "sunucuResim",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuBelge(modul) {
        var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                modul: modul,
                methodName: "sunucuBelge",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    belgeYukle(modul,name, base) {
        var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
        var param = {
            data: {
                yonetimId: userDataEstasMil["yonetimId"],
                userToken: userDataEstasMil["token"],
                firmaKodu: userDataEstasMil["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "belgeyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default controllerService



